const hostnameOf = (url?: string) => {
  try {
    return url ? new URL(url).hostname : null;
  } catch {
    return null;
  }
};

export const isBtlHost = () => {
  const btlHost = hostnameOf(import.meta.env.VITE_BTL_FRONTEND);
  const entHost = hostnameOf(import.meta.env.VITE_ENT_FRONTEND);
  return (
    !!btlHost && btlHost !== entHost && window.location.hostname === btlHost
  );
};
